import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=cbb9fa66"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"
import style0 from "./Empty.vue?vue&type=style&index=0&id=cbb9fa66&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbb9fa66')) {
      api.createRecord('cbb9fa66', component.options)
    } else {
      api.reload('cbb9fa66', component.options)
    }
    module.hot.accept("./Empty.vue?vue&type=template&id=cbb9fa66", function () {
      api.rerender('cbb9fa66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Empty.vue"
export default component.exports